import { useAuth } from "@/context/AuthContext";
import SuperadminOverview from "@/pages/dashboard/SuperadminOverview";
import TeacherHome from "@/pages/teacher/TeacherHome";
import StudentHome from "@/pages/student/StudentHome";
import AffiliatePortal from "@/pages/dashboard/AffiliatePortal";

export default function RoleHome() {
  const { user } = useAuth();
  if (user?.role === "superadmin" || user?.role === "academic_director") return <SuperadminOverview />;
  if (user?.role === "teacher") return <TeacherHome />;
  if (user?.role === "affiliate") return <AffiliatePortal />;
  return <StudentHome />;
}
